import React, {useEffect, useState} from 'react';

import {Modes} from 'lib/tactix';
import {useGroupLoad} from 'module/group/useGroup';
import {useSheetLoad} from 'module/sheet/useSheet';
import {useUserStore} from 'module/user';
import {useLayoutStore} from 'store';

import storage from './store/localStorage';
import {MigrationDialog, useMigration2to3, useMigration3to4, useMigration4to5, useMigration5to6, useMigration6to7, useMigrationToServer} from './migration';
import {useInit} from './useInit.js';

export const Bootstrap = ({mode, children}) => {
    const [block, setBlock] = useState(false);

    const setShowLoading = useLayoutStore((state) => state.setShowLoading);

    const {loading: loading1, load: loadSheets} = useSheetLoad(true);
    const {loading: loading2, load: loadGroups} = useGroupLoad(true);

    const jwt = useUserStore(state => state.user?.jwt);
    const hasJwt = !!jwt;

    const migrate2to3 = useMigration2to3();
    const migrate3to4 = useMigration3to4();
    const migrate4to5 = useMigration4to5();
    const migrate5to6 = useMigration5to6();
    const migrate6to7 = useMigration6to7();
    const migrateToServer = useMigrationToServer(mode);

    const {initData} = useInit();

    // console.log('bootstrap', block, loading1);

    useEffect(() => {
        //disable legacy migration because migration group causes duplicate key errors
        //migrate1to2();
        migrate2to3();
        migrate3to4();
        migrate4to5();
        migrate5to6();
        migrate6to7();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // load data either from local stores or from backend
    // fetch user
    useEffect(() => {
        const doInit = async () => {
            const local = !jwt;

            // ev. migrate data to server
            if (jwt && mode !== Modes.MONITOR && !storage.getItem('migrated')) {
                try {
                    setBlock(true);
                    await migrateToServer();
                } catch (e) {
                    console.log(e.cause);
                } finally {
                    setBlock(false);
                }
            }

            try {
                const sheets = await loadSheets(local);
                const groups = await loadGroups(local);
                await initData(groups, sheets);
            } catch (e) {
                console.log(e.cause);
            }
        };

        doInit();

        // Only run when hasJwt or mode changes, NOT when function refs change
        // Functions are used via closure and are functionally stable
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasJwt, mode]);

    useEffect(() => {
        setShowLoading(loading1 || loading2);
    }, [loading1, loading2, setShowLoading]);

    // do not render anything conditionally after startup, this causes the canvas handle to be changed
    // which causes errors
    return <>
        {block && <MigrationDialog mode={mode}/>}
        {children}
    </>;
};